// src/App.js
import React, { useState, useEffect } from 'react';
import '@rainbow-me/rainbowkit/styles.css';
import { getCookie, isValidChecksumAddress, setCookie } from './utils';
import {
  RainbowKitProvider,
} from '@rainbow-me/rainbowkit';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Header from './components/Header/Header';
import { config } from './config';
import styled from 'styled-components';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import MainPage from './views/MainPage/MainPage';
import HomePage from './views/HomePage';
import DisclaimerPage from './views/DisclaimerPage';
import MysteryBoxPage from './views/MysteryBoxPage/MysteryBoxPage';
import LeaderboardPage from './views/LeaderboardPage';
import "./App.css";
import { theme, ConfigProvider } from 'antd';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import Announcement from './components/Announcement';
import { notifyError, notifySuccess } from './hooks/utils';
import './i18n';
import { useTranslation } from 'react-i18next';

const queryClient = new QueryClient();

const AppContainer = styled.div`
  text-align: center;
  // max-width: 100rem; // Adjust as necessary
  margin: 0 auto;
  padding: 0 20px; // Adds padding on the left and right for smaller screens
  // background-color: transparent; // Ensure this aligns with your background color theme
`;


const App = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const ref = urlParams.get('ref');
    if (ref) {
      const checksummed = isValidChecksumAddress(ref);
      if (checksummed) {
        setCookie('ref', checksummed);
        notifySuccess(`Referral saved: ${checksummed}`);
      } else {
        notifyError(`Invalid referral address: ${ref}`);
      }
    }
  }, []);

  useEffect(() => {
  // Language preload via cookie or browser setting
  const existingLang = getCookie('i18next');

  if (existingLang) {
    i18n.changeLanguage(existingLang);
  } else {
    const browserLang = navigator.language?.split('-')[0] || 'en';
    const supportedLangs = ['en', 'cn']; // Add more if needed
    const selectedLang = supportedLangs.includes(browserLang) ? browserLang : 'en';
    i18n.changeLanguage(selectedLang);
    setCookie('i18next', selectedLang, 7); // Save for 7 days
  }
}, []);
  

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
            <ConfigProvider
            >
              <AppContainer>
                {/* <Announcement /> */}
                <Header />
                <Router>
                  <Switch>
                    <Route exact path="/" component={HomePage} />
                    <Route path="/farms/:wallet?/:id?" component={MainPage} />
                    <Route path="/disclaimer" component={DisclaimerPage} />
                    <Route path="/mystery-box" component={MysteryBoxPage} />
                    <Route path="/leaderboard" component={LeaderboardPage} />
                  </Switch>
                </Router>
                <ToastContainer
                  theme='dark' />
              </AppContainer>
            </ConfigProvider>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};

export default App;
